export function useScroll() {
  function scrollToTop() {
    const top = 0
    const behavior = 'smooth'

    window.scrollTo({ top, behavior })
  }

  function scrollToBottom() {
    const top = document.body.scrollHeight
    const behavior = 'smooth'

    window.scrollTo({ top, behavior })
  }

  function scrollToId(id: string) {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
  }

  return {
    scrollToTop,
    scrollToBottom,
    scrollToId
  }
}
